// Initialize Alpine.js

import Alpine from 'alpinejs'

import hash from './plugin.hash.js'
Alpine.plugin(hash)

import breakpoints from './plugin.breakpoints.js'
Alpine.plugin(breakpoints)

import horizontalWheel from './plugin.horizontal-wheel.js'
Alpine.plugin(horizontalWheel)

import focus from '@alpinejs/focus'
Alpine.plugin(focus)

import './data.transition.js'
import './menu.js'

window.Alpine = Alpine
